module.exports = __webpack_public_path__ + "img/treatment-wetlands.416b068f.jpg";